var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
    fill: "#C6A75E",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6668 33.3333C42.6668 39.9999 38.0002 43.3333 32.4535 45.2666C32.163 45.365 31.8475 45.3603 31.5602 45.2533C26.0002 43.3333 21.3335 39.9999 21.3335 33.3333V23.9999C21.3335 23.6463 21.474 23.3072 21.724 23.0571C21.9741 22.8071 22.3132 22.6666 22.6668 22.6666C25.3335 22.6666 28.6668 21.0666 30.9868 19.0399C31.2693 18.7986 31.6286 18.666 32.0002 18.666C32.3717 18.666 32.731 18.7986 33.0135 19.0399C35.3468 21.0799 38.6668 22.6666 41.3335 22.6666C41.6871 22.6666 42.0263 22.8071 42.2763 23.0571C42.5264 23.3072 42.6668 23.6463 42.6668 23.9999V33.3333Z",
    stroke: "#C6A75E",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/icon7.c161cdd784dde33aab0211f83fb87642.svg";
export { ForwardRef as ReactComponent };